import { Alert } from '@/components/ui/alert';

export function SlowNotice({ text }: { text: string }) {
  return (
    <p role="status" className="self-start text-sm" style={{ color: 'var(--naia-text-secondary)' }}>
      {text}
    </p>
  );
}

export function RetryAlert({ message, partial, onRetry }: { message: string; partial?: boolean; onRetry: () => void }) {
  return (
    <div className="flex flex-col gap-2 items-start">
      <Alert>{message}</Alert>
      {partial && (
        <p className="text-xs" style={{ color: 'var(--naia-text-secondary)' }}>
          Réponse incomplète — le début reçu est conservé ci-dessus.
        </p>
      )}
      <button
        type="button"
        onClick={onRetry}
        className="min-h-[44px] px-4 rounded-md text-sm font-medium"
        style={{ background: 'var(--naia-blue)', color: '#fff' }}
      >
        Réessayer
      </button>
    </div>
  );
}
